import { ColumnOrder, ColumnOrderEnum } from './order';

interface Pageable {
  linha?: number;
  pagina?: number;
  registros?: number;
  total?: number;
}

enum Order {
  asc,
  desc
}

export class MatPageable implements Pageable {
  linha?: number;
  pagina?: number;
  registros?: number;
  total?: number;
  sort?: ColumnOrder;

  constructor(page?: number, size?: number, sort?: ColumnOrder) {
    this.pagina = page != undefined ? page : 0;
    this.registros = size != undefined ? size : 9999999;
    this.sort = sort;
  }

  public get query() {
    return `?page=${this.pagina}&size=${this.registros}&pageNumber=${this.pagina}&pageSize=${this.registros}${this.order}`;
  }

  public get order() {
    return this.sort && this.sort.key && this.sort.value ? `&sort=${this.sort.key},${this.parseOrder}` : '';
  }

  get parseOrder() {
    if (this.sort) {
      switch (this.sort.value) {
        case ColumnOrderEnum.ascend:
          return 'asc';
        case ColumnOrderEnum.descend:
          return 'desc';
      }
    }
    return '';
  }
}

export interface PageableResponse<T> {
  content: Array<T>;
  totalElements: number;
  pageable: { sort: any, pageSize: number, pageNumber: number, offset: number, unpaged: boolean }
  totalPages: number;
  last: boolean;
  first: boolean;
  sort: { sorted: boolean, unsorted: boolean, empty: boolean }
  numberOfElements: number;
  size: number;
  number: number;
  empty: boolean;
}
